<h2 mat-dialog-title>Validation de l'action</h2>
<div mat-dialog-content class="mat-typography">
    {{ data.message }}
</div>

<mat-dialog-actions align="end">
  <button mat-button [mat-dialog-close]="false">Non</button>
  <button mat-button [mat-dialog-close]="true" cdkFocusInitial>Oui</button>
</mat-dialog-actions>
